<av-content-container>
  <div class="col-12 d-flex align-items-stretch">
    <av-table-card
      [titleKey]="'app.device.activity_log.sections.activity_log.title'"
      icon="history"
      [columns]="columns"
      [rows]="rows()"
      [countLabelKey]="'app.device.activity_log.count.logs_found_suffix'"
      [emptyTextKey]="'app.device.activity_log.empty.activity_log'"
      [pageSize]="10"
      [truncateAfter]="60" />
  </div>
</av-content-container>
